import { render, staticRenderFns } from "./AudioPlay.vue?vue&type=template&id=956c3c0a&"
import script from "./AudioPlay.vue?vue&type=script&lang=js&"
export * from "./AudioPlay.vue?vue&type=script&lang=js&"
import style0 from "./AudioPlay.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AudioPlay.vue"
export default component.exports